import React from "react";
import Lottie from "lottie-react";
import ailoading from "../assets/lottie/Gift premium animation.json"
import "../assets/styles/commingsoon.css";

export default function ComingSoon() {
  return (
    <div className="coming-soon d-flex flex-column align-items-center justify-content-center">
      <Lottie
        style={{ width: "120px", height: "120px" }}
        animationData={ailoading}
        loop={true}
      />
      <h1 className="shiny-text mt-4">Event is on the way,<br/><br/> Stay tuned...</h1>
    </div>
  );
}
